import { LateFeeConfigType, PaymentTransactionType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { LATE_FEE_CONFIGS, PAYMENT_TRANSACTIONS } from "../../utils/constants";

export const createPaymentTransaction = async (data: PaymentTransactionType) => await post<PaymentTransactionType, string>(PAYMENT_TRANSACTIONS, data);
export const updatePaymentTransaction = async (data: PaymentTransactionType) => await put<PaymentTransactionType, string>(PAYMENT_TRANSACTIONS, data);

export const getPaymentTransactions = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    if (data?.IdPaymentType) {
        queryParams.append('IdPaymentType', data.IdPaymentType);
    }
    if (data?.IdStudent) {
        queryParams.append('IdStudent', data.IdStudent);
    }
    if (data?.IdStudentDebt) {
        queryParams.append('IdStudentDebt', data.IdStudentDebt);
    }
    const url = `${PAYMENT_TRANSACTIONS}?${queryParams.toString()}`;
    return await get<PagedResultsType<PaymentTransactionType>>(url)
};